import{jsx as o}from"react/jsx-runtime";import{useCallback as r}from"react";import{styled as t}from"styled-components";import{calcMainAreaWidth as i}from"../services/calcSize.mjs";import{MAIN_AREA as e}from"../constants/ElementId.mjs";import{useSize as m}from"../hooks/useSize.mjs";const s=t.div`
  margin-left: 12px;
  margin-right: auto;
  overflow: visible;
  float: left;
  background-color: #ffffff;
  border: 1px solid #777777;
  border-radius: 2px;
  box-shadow: 2px 2px 2px #888888;

  /** 抽出条件画面下部Submitボタン領域*/
  fieldset .buttons {
    float: right;
  }
`;function f({children:t}){const f=r((o=>o(`${i()}px`)),[]),n=m("1180px",f);return o(s,{id:e,style:{width:n},children:t})}export{f as MainArea};
